import { useQuery } from '@tanstack/react-query'

import { useTRPC } from '@langmail/shared-ui'

export function useStatusLine() {
  const trpc = useTRPC()
  // A health readout must not freeze: the app turns window-focus refetches off
  // globally, so refresh on a timer and on focus.
  return useQuery({ ...trpc.statusLine.get.queryOptions(), refetchInterval: 60_000, refetchOnWindowFocus: true })
}
